export const ColorConfig = {
    primary: "#508FF4",
    default:"#ffffff"
}